/**
 * The build-time provider switch, on its own so `src/App.tsx` can read it in
 * every build without importing the auth package: a `none` build must carry no
 * Amplify, and the full cognito resolution (`./auth.ts`) lives in the lazy
 * cognito chunk for that reason.
 */

export type AuthProvider = 'none' | 'cognito';

export class AuthConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthConfigError';
  }
}

/**
 * Exact match on purpose: `src/App.tsx` compares the raw env value the same way
 * to decide which provider is in the bundle, and the two must never disagree.
 * Unset or empty is `none`, so a build without the variable behaves as before.
 */
export function parseAuthProvider(raw: string | undefined): AuthProvider {
  const value = raw ?? '';
  if (value === '' || value === 'none') return 'none';
  if (value === 'cognito') return 'cognito';
  throw new AuthConfigError(
    `Invalid VITE_AUTH_PROVIDER="${value}" (expected exactly "none" or "cognito").`,
  );
}
